<template>
  <b-input-group :size="size">
    <b-input-group-prepend v-if="label" is-text>
      {{ label }}

      <required-symbol v-if="required"/>
    </b-input-group-prepend>

    <b-btn
      class="form-control shadow-none input-button"
      :class="{'rouned-right text-left': $dir.ltr, 'rounded-left text-right': $dir.rtl}"
      @click="toggleShow"
    >
      <template v-if="model">
        <font-awesome-icon
          icon="circle"
          fixed-width
          :style="{ 'color': model }"
          class="align-middle"
          :class="{ 'mr-1': $dir.ltr, 'ml-1': $dir.rtl }"
        />

        <span dir="ltr">
          {{ model }}
        </span>
      </template>
    </b-btn>

    <b-card v-if="show" class="content position-absolute" body-class="p-0">
      <div :class="{'pr-1': $dir.ltr, 'pl-1': $dir.rtl}">
        <div
          class="mt-1 p-1 bg-light rounded d-flex align-items-center justify-content-between small"
          :class="{'ml-1': $dir.ltr, 'mr-1': $dir.rtl}"
        >
          {{ $t('shared.selectedColor') }}:
          <span dir="ltr">{{ model }}</span>
        </div>

        <div v-for="(color, index) in colors" :key="color" class="d-inline-block mt-1" :class="{'ml-1': $dir.ltr, 'mr-1': $dir.rtl}">
          <b-btn class="color-btns p-0 shadow-none border-0" :id="`clr-${index}`" :style="{backgroundColor: color}" v-b-tooltip @click="setColor(color)"></b-btn>

          <b-tooltip :target="`clr-${index}`" triggers="hover">
            <span dir="ltr">
              {{ color }}
            </span>
          </b-tooltip>
        </div>
      </div>

      <b-input-group v-if="customColor" :prepend="$t('shared.customColor')" size="sm" class="m-1 custom-width">
        <b-input type='color' v-model="model" class="shadow-none"/>
      </b-input-group>
    </b-card>
  </b-input-group>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    value: String,
    label: String,
    required: { type: Boolean, default: false },
    customColor: { type: Boolean, default: true },
    size: { type: String, default: 'md' },
    colors: { type: Array, default: () => { return [
      '#f44336', // Red
      '#e91e63', // Pink
      '#9c27b0', // Purple
      '#673ab7', // Deep Purple
      '#3f51b5', // Indigo
      '#2196f3', // Blue
      '#03a9f4', // Light Blue
      '#00bcd4', // Cyan
      '#009688', // Teal
      '#4caf50', // Green
      '#8bc34a', // Light Green
      '#cddc39', // Lime
      '#ffeb3b', // Yellow
      '#ffc107', // Amber
      '#ff9800', // Orange
      '#ff5722', // Deep Orange
      '#795548', // Brown
      '#9e9e9e', // Grey
      '#607d8b', // Blue Grey
      '#000000' // Black
    ] } }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    document.documentElement.addEventListener('click', this.onExit, false)
  },
  beforeDestroy: function () {
    document.documentElement.removeEventListener('click', this.onExit, false)
  },
  methods: {
    onExit (ev) {
      if (!this.$el.contains(ev.target)) this.hide()
    },
    toggleShow () {
      this.show = !this.show
    },
    hide () {
      this.show = false
    },
    setColor (color) {
      this.model = color
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  top: 100%;
  z-index: 1;

  *[dir="ltr"] & {
    left: 0;
    right: unset;
  }

  *[dir="rtl"] & {
    right: 0;
    left: unset;
  }
}

.color-btns {
  width: 30.5px;
  height: 30.5px;
}

.custom-width {
  width: calc(100% - .5rem) !important;
}
</style>